/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { GroupThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import Text from 'components/common/Text';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { LocalText } from "../../common/LocalText";

const CheckYourInbox = ({ titlePhrase, notificationPhrase, email, organizationName }) => (
  <GroupThemedContentPanelWithFullHeader isFixedWidth titlePhrase={titlePhrase} subTitle={<LocalText text={organizationName}/>}>
    <WhiteCardWithWidePadding>
      {
        email && (
          <section style={{ marginBottom: 24 }}>
            <Text size="body" className="font-color-gsDark">
              {email}
            </Text>
          </section>
        )
      }


      <section>
        <pre style={{ wordBreak: 'break-word' }} className="font-color-gsDark">
          <Text size="body">
            <FormattedMessage {...notificationPhrase} />
          </Text>
        </pre>
      </section>

      <section style={{ marginTop: 24 }}>
        <Text size="body" colorName="middle-gray">
          <FormattedMessage id="checkInbox.spam.message.text" />
        </Text>
      </section>
    </WhiteCardWithWidePadding>
  </GroupThemedContentPanelWithFullHeader>
);

export default CheckYourInbox;